import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../pages/login/connect/Login";
import LoginAlert from "../LoginAlert/LoginAlert";
import ProgramSettings from "../../pages/ProgramSettings/ProgramSettings";
import EditProfileBusiness from "../../pages/EditProfileBusiness/EditProfileBusiness";
import InviteFriendModal from "../InviteFriendModal/InviteFriendModal";

function DesktopSidebar() {
  const [isShowAppSettingModal, setIsShowAppSettingModal] = useState(false);
  const [isShowAppEditProfileModal, setIsShowAppEditProfileModal] = useState(false);
  const [isShowInviteFriendModal, setIsShowInviteFriendModal] = useState(false);
  const { getUserInfoByToken } = useAuth((state) => state.actions);
  useEffect(() => {
    getUserInfoByToken(0)
  }, [])
  const menuItems = [
    {
      id: 1,
      title: "اعلان ها",
      link: "/NotificationsPage",
      url: "menu-des-1.svg",
    },
    { id: 2, title: "   پشتیبانی", link: "/Messages", url: "menu-des-10.svg" },
    {
      id: 13,
      // title: "  خرید اشتراک ",
      title: "خرید اشتراک",
      link: "/BuyFilingSubscription",
      url: "menu-des-13.svg",
    },
    { id: 3, title: "تنظیمات برنامه", url: "menu-des-3.svg" },
    { id: 4, title: "ویرایش پروفایل", url: "menu-des-4.svg" },
    {
      id: 15,
      title: "اشتراک های من  ",
      link: "/MySubscription",
      url: "eshterak.svg",
    },
    // {
    //   id: 5,
    //   title: "مدیریت آگهی ها",
    //   link: "/AdManagement",
    //   url: "menu-des-5.svg",
    // },

    {
      id: 6,
      title: " نشان شده‌ها   ",
      link: "/Shown",
      url: "menu-des-6.svg",
    },
    {
      id: 17,
      title: " جوایز    ",
      link: "/rewards",
      url: "gray-reward.svg",
    },
    {
      id: 16,
      title: "  دعوت از دوستان   ",
      url: "invite-a-friend.svg",
      link: "/Rewards/InviteAdFriends",
    },
    // { id: 7, title: "حراجی ها", link: "/Auctions", url: "menu-des-7.svg" },
    // {
    //   id: 8,
    //   title: "کیف پول و پرداخت ها",
    //   link: "/Wallet",
    //   url: "menu-des-8.svg",
    // },
    // { id: 8, title: "پلنر", link: "/Planner", url: "menu-des-9.svg" },

    {
      id: 14,
      title: " کیف پول  ",
      link: "/Wallet",
      url: "menu-des-8.svg",
    },
    {
      id: 9,
      title: "راهنما",
      link: "/PelakHelp",
      url: "menu-des-10.svg",
    },
    { id: 12, title: " نصب پلاک من", link: "InstallPelak", url: "receive-square.svg" },
    {
      id: 10,
      title: "قوانین و مقررات",
      link: "/TermsAndConditions",
      url: "menu-des-11.svg",
    },
    { id: 11, title: "درباره پلاک من", link: "/AboutPelakeMan", url: "menu-des-12.svg" },
    // {
    //   id: 12,
    //   title: "کاربران مسدود شده",
    //   link: "/BlackList",
    //   url: "blocked-users.svg",
    // },


  ];

  return (
    <>
      <div className="desktop-sidebar rounded-xl py-6 px-2 top-0 z-30 relative  col-span-1     h-screen sm:hidden md:hidden 2xl:col-span-1 ">
        <div className="flex flex-col gap-8 bg-white  fixed top-12 h-full overflow-auto mt-[2rem]">
          {menuItems.map((item) => (
            <div
              key={item.id}
              className="desktop-sidebar-items cursor-pointer w-full flex gap-3 items-center justify-start px-3 z-40 hover:font-bold transition-all bg-white"
            >
              <img
                src={`/desktop/icons/${item.url}`}
                alt=""
              />
              {item.link ? (
                <Link className="text-gray-600" to={item.link}>
                  <p>{item.title}</p>
                </Link>
              ) : item.id == 3 ? (
                <p
                  onClick={() => setIsShowAppSettingModal(true)}
                  className="text-gray-600"
                >
                  {item.title}
                </p>
              ) :
                item.id === 16 ? (<p
                  onClick={() => setIsShowInviteFriendModal(true)}
                  className="text-gray-600"
                >
                  {item.title}
                </p>) :


                  (
                    <p
                      onClick={() => setIsShowAppEditProfileModal(true)}
                      className="text-gray-600"
                    >
                      {item.title}
                    </p>
                  )}
            </div>
          ))}

          <div className="w-full flex items-center justify-center flex-col">
            <div className="w-full flex gap-3 my-1 items-center justify-center px-3">
              <img src="icons/eyeIcon.svg" alt="" />
              <p>بازدید امروز:</p>
              <p>478</p>
            </div>
            <div className="w-full flex gap-3 my-1 items-center justify-center px-3">
              <p>نسخه :</p>
              <p>v.1.1</p>
            </div>
          </div>
        </div>
      </div>

      {isShowAppSettingModal && (
        <div
          className={`fade-in modal z-50 fixed top-0 w-full h-screen flex items-center justify-center bg-[#8d8d8da1]`}
        >
          <div className="rounded-xl p-2 bg-white flex flex-col items-center justify-center gap-4 w-[70%] shadow-sm relative">
            <div className="flex items-end justify-end w-full p-2">
              <img
                onClick={() => setIsShowAppSettingModal(false)}
                src="/icons/close-black.svg"
                alt=""
              />
            </div>
            <ProgramSettings setIsShowAppSettingModal={setIsShowAppSettingModal} />
          </div>
        </div>
      )}

      {isShowAppEditProfileModal && (
        <div
          onClick={(e) => {
            if (
              e.target.className.includes(
                "style-for-close-on-outside-edit-profile"
              )
            ) {
              document.removeEventListener(
                "click",
                setIsShowAppEditProfileModal(false)
              );
            }
          }}
          className={`style-for-close-on-outside-edit-profile fade-in modal z-50 fixed top-0 w-full h-screen flex items-center justify-center py-4 bg-[#8d8d8da1]  `}
        >
          <div className="rounded-xl p-2 bg-white flex flex-col items-center justify-center gap-4 w-[80%] shadow-sm relative">
            <div className="flex items-end justify-end w-max p-2 mt-5 absolute left-8 top-3">
              <img
                className="cursor-pointer"
                onClick={() => setIsShowAppEditProfileModal(false)}
                src="/icons/close-black.svg"
                alt=""
              />
            </div>
            <EditProfileBusiness
              setIsShowEditProfileModal={setIsShowAppEditProfileModal}
              isShowAppEditProfileModal={isShowAppEditProfileModal}
            />
          </div>
        </div>
      )}

      {isShowInviteFriendModal && (
        <InviteFriendModal setIsShowInviteFriendModal={setIsShowInviteFriendModal} />
      )}
    </>
  );
}

export default DesktopSidebar;
